import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "checkbox-label" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["for"]
const _hoisted_4 = ["id", "checked", "onChange"]
const _hoisted_5 = { class: "buttons" }

import { LockHistoryItem } from "@/services/entities/LockHistoryItem";
import { useReportingMonthStore } from "@/stores/reporting";
import { useLockItemsStore } from "@/stores/lock";
import { Authorization } from "@/services/authenticate";
import { formatMXDateRange } from "@/common/date";
import { showToastError } from "@/toastification";



export default /*@__PURE__*/_defineComponent({
  __name: 'LockDetail',
  props: {
  locks: { Type: [] as LockHistoryItem[], default: [] as LockHistoryItem[] },
  userName: { Type: {} as string, default: "Unknown" as string },
  userId: { Type: {} as string, default: "" as string },
  year: { Type: {} as number },
  month: { Type: {} as number },
},
  emits: ["delete", "change", "close", "refreshUsers"],
  setup(__props, { emit: __emit }) {

const lockStore = useLockItemsStore();
const reportingStore = useReportingMonthStore();
const emit = __emit;

const props = __props;

function onLockedChanged(lock: LockHistoryItem, event: Event) {
  let isLocked = (event.target as HTMLInputElement).checked;
  lock.isLocked = isLocked;
}

function getIsLockChecked(lock: LockHistoryItem): boolean {
  return lock.isLocked;
}

function addInterval() {
  let newInterval = {
    dateFrom: new Date(),
    dateTo: new Date(),
    isLocked: false,
    isPlaceholder: false,
    lockedUserId: props.userId,
  } as LockHistoryItem;
  props.locks.push(newInterval);
}

async function save() {
  let hasError = false;
  props.locks.forEach((a: LockHistoryItem) => {
      a.dateFrom = new Date(a.range.length >=1 ? a.range[0] : a.dateFrom);
      a.dateTo = new Date(a.range.length >= 2 ? a.range[1] : a.dateTo);
      a.range = [a.dateFrom, a.dateTo];
      if (a.dateFrom.getMonth() != a.dateTo.getMonth()) {
        showToastError("Date range cannot span multiple months");
        hasError = true;
      }
  });  
  if (hasError) {
    return;
  }
  await lockStore.saveLockItems(props.locks, props.userId, Authorization.id);
  emit('refreshUsers');
  await reportingStore.loadReportingMonth(
    props.year,
    props.month,
    props.userId
  );
}

return (_ctx: any,_cache: any) => {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h4", null, "Locks for " + _toDisplayString(props.userName), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.locks, (lock) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "table-detail",
        key: lock.id
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("label", {
            for: 'range_' + lock.id
          }, "Interval: ", 8, _hoisted_2),
          _createVNode(_component_VueDatePicker, {
            modelValue: lock.range,
            "onUpdate:modelValue": ($event: any) => ((lock.range) = $event),
            range: "",
            "enable-time-picker": false,
            teleport: true,
            clearable: false,
            id: 'range_' + lock.id,
            utc: "preserve",
            class: "rangeRM stool",
            format: _unref(formatMXDateRange)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "format"]),
          _createElementVNode("label", {
            for: 'lock_' + lock.id
          }, "Is locked: ", 8, _hoisted_3),
          _createElementVNode("input", {
            id: 'lock_' + lock.id,
            type: "checkbox",
            checked: getIsLockChecked(lock),
            onChange: ($event: any) => (onLockedChanged(lock, $event)),
            class: "stool"
          }, null, 40, _hoisted_4)
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (addInterval()))
      }, "+ Add interval"),
      _createElementVNode("button", {
        class: "accent",
        onClick: save
      }, "Save")
    ])
  ]))
}
}

})